import { useCallback, useEffect, useMemo, useRef, useState } from 'react'

const FLASH_DURATION_MS = 1400

const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false

const useClientTabFocusProvider = () => {
  const [flashedCardId, setFlashedCardId] = useState<string | null>(null)
  const timer = useRef<ReturnType<typeof setTimeout>>()

  const focusCard = useCallback((anchorId: string, cardId: string) => {
    document.getElementById(anchorId)?.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    })
    clearTimeout(timer.current)
    setFlashedCardId(cardId)
    timer.current = setTimeout(() => setFlashedCardId(null), FLASH_DURATION_MS)
  }, [])

  useEffect(() => () => clearTimeout(timer.current), [])

  return useMemo(() => ({ flashedCardId, focusCard }), [flashedCardId, focusCard])
}

export default useClientTabFocusProvider
